// Shared helper: is the app running in embedded mode?
// True when inside an iframe (window.self !== window.top) OR when the URL
// contains ?embedded=1. Kept in sync with the early inline script in
// public/index.html that adds the `rd-embedded` class before first paint.
export function isEmbedded() {
  if (typeof window === "undefined") return false;

  let inIframe = false;
  try {
    inIframe = window.self !== window.top;
  } catch {
    // Cross-origin access was blocked -> we are inside a frame.
    inIframe = true;
  }

  let hasParam = false;
  try {
    hasParam = new URLSearchParams(window.location.search).get("embedded") === "1";
  } catch {
    hasParam = false;
  }

  return inIframe || hasParam;
}

export default isEmbedded;
